import 'core/i18n/i18n.config'; // [⚠] Make sure i18n instance is configured before anything else.
import {
  completeSilentRenew,
  isSilentRenewResponseInFrame,
} from 'core/auth/silent-renew-callback.service';
import { InactivityLogoutContainer } from 'layout/inactivity-logout';
import { startNativeBackButton } from 'core/platform/native-back-button.service';
import { lockPortraitOrientation } from 'core/platform/screen-orientation.service';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { GlobalStyle } from 'styles';
import { AppProviders } from './app.providers';
import { AppRouter } from './app.router';
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const App: React.FC = () => {
  return (
    <AppProviders>
      <GlobalStyle />
      <InactivityLogoutContainer />
      <AppRouter />
    </AppProviders>
  );
};

if (isSilentRenewResponseInFrame()) {
  void completeSilentRenew();
} else {
  lockPortraitOrientation();
  startNativeBackButton();
  root.render(<App />);
}
